import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import store from "./app/store";
import { Provider } from "react-redux";
import { Amplify, Cache } from "aws-amplify";
import awsExports from "./aws-exports";
import { MsalProvider } from "@azure/msal-react";
import msalInstance from "./app/msal";
import {EventType} from "@azure/msal-browser";
Amplify.configure(awsExports);
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
  }
});

let logoutTimeout;
msalInstance.addEventCallback(async (event) => {
  if (event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS && event.payload.account) {

    const email = event.payload.account.username
    const issDomain = email.split('@')[1];

    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
    // preventing users out of daikin to login to the portal
    if (["daikincomfort.com"].indexOf(issDomain) === -1) {
      const account = msalInstance.getActiveAccount();
      await msalInstance.logoutRedirect({
        logoutHint: account.idTokenClaims.login_hint,
      });
      const location = window.location.origin
      console.log({location})
      return;
    }

    if (!logoutTimeout) {
      logoutTimeout = setTimeout(async () => {
        const account = msalInstance.getActiveAccount();
        await msalInstance.logoutRedirect({
          logoutHint: account.idTokenClaims.login_hint,
        })
      }, 5000);
    }

    if (Math.floor(Date.now()/1000 ) < event.payload.idTokenClaims.exp) {
      clearTimeout(logoutTimeout);
    }

    Cache.setItem("federatedInfo", {
      token: event.payload.idToken,
    });
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <MsalProvider instance={msalInstance}>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </MsalProvider>
);
